// extracted by mini-css-extract-plugin
export default {"wrap":"GL-z","fullWidth":"HL-z","hideOnDesktop":"IL-z","content":"JL-z","hasOpenedNav":"KL-z","crumbsList":"LL-z","dropdownsWrap":"ML-z"};